import React from 'react';

import s from './plus_minus.module.css';

export const PlusMinus = (props: { type: 'plus' | 'minus' | 'x'; class?: string }) => {
    switch (props.type) {
        case 'plus':
            return <span className={`${s.plus} ${props.class}`} />;
        case 'minus':
            return <span className={`${s.minus} ${props.class}`} />;
        case 'x':
            return <span className={`${s.x} ${props.class}`} />;
    }
};

export default PlusMinus;
